import { render, staticRenderFns } from "./BigCategory.vue?vue&type=template&id=d2a28792&scoped=true&"
import script from "./BigCategory.vue?vue&type=script&lang=js&"
export * from "./BigCategory.vue?vue&type=script&lang=js&"
import style0 from "./BigCategory.vue?vue&type=style&index=0&id=d2a28792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a28792",
  null
  
)

export default component.exports